import { LEGAL_ENTITY } from './LegalEntity';

export const SUPPORT_EMAIL = LEGAL_ENTITY.supportEmail;

export const buildSupportMailto = ({ subject, body } = {}) => {
  const parts = [];
  if (subject) {
    parts.push(`subject=${encodeURIComponent(subject)}`);
  }
  if (body) {
    parts.push(`body=${encodeURIComponent(body)}`);
  }

  return parts.length > 0
    ? `mailto:${SUPPORT_EMAIL}?${parts.join('&')}`
    : `mailto:${SUPPORT_EMAIL}`;
};
